<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="nav-bar box-horizontal mb-0">
              <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
              <div class="flex-1">
                <h3 class="m-0">Pembayaran by Admin</h3>
                <p class="mb-0">Semua pembayaran disini ada gan</p>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <!-- <router-link :to="{ name: 'tambahTarifVoucher'}"  class="btn btn-primary" >Tambah Tarif Voucher</router-link> -->
                <label class="text-dark">Tanggal Dari</label>
                <vuejs-datepicker placeholder="Tanggal Dari..." style="width:100%" v-model="data.tglDari"></vuejs-datepicker>
                <label class="text-dark mt-2">Sampai</label>
                <vuejs-datepicker placeholder="Tanggal Sampai..." style="width:100%" v-model="data.tglSampai"></vuejs-datepicker>
              </div>
              <div class="col-md-3">
                <label class="text-dark">Admin</label>
                <p class="pointer text-info" @click="data.modalAdmin = true;theGet.admin()">
                  <span v-if="data.admin == null">Pilih Admin</span>
                  <span v-else>{{data.admin}}</span>
                </p>
                <label class="text-dark mt-2">Area</label>
                <p class="pointer text-info" @click="data.modalArea = true;theGet.area()">
                  <span v-if="data.area == null">All</span>
                  <span v-else>{{data.area}}</span></p>
              </div>
              <div class="col-md-3">
                <button class="btn btn-sm btn-warning" @click="theGet.datae()">Filter</button>
              </div>
            </div>
            <div class="card">
              <div class="card-header card-header-info" v-show="false">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">History Pembayaran</h4>
                    <p class="card-category">Berikut History pembayaran</p>
                  </div>
                  <div class="col-md-6" v-show="false">
                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <th width="40px">No.</th>
                      <th>Nama Pelanggan</th>
                      <th>Area</th>
                      <th>Bulan Bayar</th>
                      <th>Paket</th>
                      <th>Tanggal Bayar</th>
                      <th>Admin</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.unama }}</br> <span class="text-secondary">WA : {{ u.wa }}</span></td>
                        <td>{{ u.anama }}</td>
                        <td>{{ myGlobal.BulanOnly(u.htanggal) }}</td>
                        <td>{{ u.pnama }}</br> {{ribu(u.paket_tarif)}}</td>
                        <td>{{ myGlobal.tglIndo(u.hbayar_tanggal) }}</td>
                        <td>{{ u.by_admin }}</td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                      <tr v-if="theGet.data.List != null">
                        <td></td>
                        <td><strong>Total</strong></td>
                        <td></td>
                        <td></td>
                        <td><strong>{{myGlobal.ribu(theGet.data.total)}}</strong></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>
    </div>
    
    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="data.modalAdmin">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Admin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalAdmin = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive" style="height: 500px;overflow:auto;">
                  <table class="table">
                    <thead>
                      <th>Nama</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.ListAdmin">
                        <td class="pointer" @click="data.modalAdmin = false, data.admin = u.nama">{{ u.nama }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="data.modalArea">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Admin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalArea = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive" style="height: 500px;overflow:auto;">
                  <table class="table">
                    <thead>
                      <th>Nama</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.ListArea">
                        <td class="pointer" @click="data.modalArea = false, data.area = u.anama, data.areaid = u.aid">{{ u.anama }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 
    vuejsDatepicker,
    moment
  }, 
  setup() {
    const data = reactive({
      filtered: '',
      namaAdmin: '',
      tglDari: null,
      tglSampai: null,
      admin: null,
      area: null,
      areaid: null,
      modalAdmin: false

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
        List: [],
        ListAdmin: [],
        ListArea: [],
        total: 0
      }),
	    datae() {
        // moment(this.sampaiTanggal).format('YYYY-MM-DD')
        if (data.tglDari != null) {
          data.tglDari = moment(data.tglDari).format('YYYY-MM-DD')
        }
        if (data.tglSampai != null) {
          data.tglSampai = moment(data.tglSampai).format('YYYY-MM-DD')
        }

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          dari: data.tglDari,
          sampai: data.tglSampai,
          admin: data.admin,
          area: data.areaid,
        };
    
        var apiUrl = inter.pembayaranByAdmin();
        myGlobal.call(datax,apiUrl).then(x => {
            //console.log(JSON.stringify(x));
            if (x.status == true) {
              this.data.List = x.data;
              theGet.data.total = x.pesan;
            } else {
              this.data.List = null;
            }
        })
      },
	    admin() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.getHistoryByAdmin();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            this.data.ListAdmin = x.data;
          } else {
              //alert(x.pesan);
          }
        })
      },
	    area() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.getHistoryByArea();
        myGlobal.call(datax,apiUrl).then(x => {
          console.log(JSON.stringify(x));
          if (x.status == true) {
            this.data.ListArea = x.data;
          } else {
              //alert(x.pesan);
          }
        })
      }
    }

    return {
      data, 
      theGet,
      myGlobal
    }

  },
  mounted () {
      document.title = "History Pembayaran";

      this.theGet.datae();

      this.data.namaAdmin = this.$route.params.nama;
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/history-pembayaran/main.vue